export const setRoles = (state, data) => {
    state.roles = data;
};

export const setUsers = (state, data) => {
    state.users = data;
};
